import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}) {
  return (
    <div
      className={cn("animate-pulse bg-surface-sunken", className)}
      {...props} />
  );
}

export { Skeleton }
